module.exports = __webpack_public_path__ + "img/08.26fac6fc.jpg";